export default function createSlug(Text)
{
  return Text
      .toLowerCase()
      .replace(/[^\w ]+/g,'')
      .replace(/ +/g,'-') + "-"+Math.floor(1000 + Math.random() * 9000);;
}